import { IState } from 'reducers/reducers';
import { ITypeHeaderProps } from 'components/contentTypes/CustomTypeInput';
import { ArchiveButton } from './ArchiveButton';
import { HeaderWrapper } from './ListHeaderWrapper';

export function entrySelector(id: string, type: string) {
  return (state: IState) => {
    const data = state.content.data[type] ?? [];

    return data.find((d) => d._id === id);
  };
}

export function ArchiveHeader(props: ITypeHeaderProps) {
  return (
    <HeaderWrapper>
      <ArchiveButton {...props} />
    </HeaderWrapper>
  );
}
